import type { JSX } from '@builder.io/qwik';
import { component$, useSignal, useOnDocument, $ } from '@builder.io/qwik';
import type { MMContentEmbedBlockAttsInterface } from '~/types/AppData/Blocks/MMContentEmbedBlockInterface';

// TODO: do we want to load this on intersection or on page load? Could use useTask$ instead
export default component$(
  ({ html }: MMContentEmbedBlockAttsInterface): JSX.Element => {
    const embedHTML = useSignal('');

    // This uses an intersection observer on the client side to update the signal and load the iframe
    // when it is scrolled into view
    // Throws a linter warning because it can be misused, but this is a good use case for it
    // eslint-disable-next-line qwik/no-use-visible-task
    useOnDocument(
      'load',
      $(() => {
        embedHTML.value = html;

        if (window.__mm_content_enrichment__) {
          window.__mm_content_enrichment__.renderEmbeds();
        } else {
          const script = document.createElement('script');
          script.async = true;
          script.src =
            'https://assets.minutemediacdn.com/content-enrichment/embeds.js';

          document.head.appendChild(script);
        }
      })
    );

    return <figure dangerouslySetInnerHTML={embedHTML.value} />;
  }
);
